// İlerleme Yüzdesi (0-100) için Renk & Tema Yardımcısı
// Kırmızıdan başlayıp yeşile doğru giden dinamik ve hafif renkli (pastel) zemin & çubuk teması

export interface ProgressTheme {
  percent: number;
  barColor: string;
  barGradient: string;
  bgTint: string;      // Hafif pastel zemin rengi
  badgeBg: string;     // Yüzde rozeti zemin rengi
  borderTint: string;  // Hafif çerçeve rengi
  trackBg: string;     // Çubuk oluğu / ray rengi
  textColor: string;   // Metin ve yüzde rakam rengi
  labelColor: string;  // Başlık / etiket rengi
}

export const getProgressTheme = (percent: number): ProgressTheme => {
  const p = Math.max(0, Math.min(100, Math.round(percent || 0)));

  // 1. Kırmızı (0% - 29%): Düşük / Başlangıç Seviyesi
  if (p < 30) {
    return {
      percent: p,
      barColor: '#ef4444',
      barGradient: 'linear-gradient(90deg, #f87171 0%, #ef4444 100%)',
      bgTint: 'rgba(254, 242, 242, 0.95)',
      badgeBg: '#fee2e2',
      borderTint: '#fca5a5',
      trackBg: '#fee2e2',
      textColor: '#dc2626',
      labelColor: '#991b1b'
    };
  }

  // 2. Turuncu / Amber (30% - 59%): Gelişme Aşamasında
  if (p < 60) {
    return {
      percent: p,
      barColor: '#f59e0b',
      barGradient: 'linear-gradient(90deg, #fb923c 0%, #f59e0b 100%)',
      bgTint: 'rgba(255, 251, 235, 0.95)',
      badgeBg: '#fef3c7',
      borderTint: '#fde68a',
      trackBg: '#fef3c7',
      textColor: '#b45309',
      labelColor: '#92400e'
    };
  }

  // 3. Fıstık Yeşili / Lime (60% - 84%): İleri Seviye
  if (p < 85) {
    return {
      percent: p,
      barColor: '#84cc16',
      barGradient: 'linear-gradient(90deg, #a3e635 0%, #65a30d 100%)',
      bgTint: 'rgba(247, 254, 231, 0.95)',
      badgeBg: '#ecfccb',
      borderTint: '#d9f99d',
      trackBg: '#ecfccb',
      textColor: '#4d7c0f',
      labelColor: '#3f6212'
    };
  }

  // 4. Zümrüt Yeşili (85% - 100%): Neredeyse Tamamlandı / Başarılı
  return {
    percent: p,
    barColor: '#10b981',
    barGradient: 'linear-gradient(90deg, #34d399 0%, #059669 100%)',
    bgTint: 'rgba(236, 253, 245, 0.95)',
    badgeBg: '#d1fae5',
    borderTint: '#a7f3d0',
    trackBg: '#d1fae5',
    textColor: '#047857',
    labelColor: '#065f46'
  };
};
